import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetClientListNetwork,
  getMonthsYearsAction,
} from "../../../redux/actions/GlobalAction";
import Select from "react-select";
import { getAllProviderListNetworkAction } from "../../../redux/actions/TestPackageNetworkAction";
import { placeholderSelectColor } from "../NetworkIntelligence/UsageCoverage/helper";
import { InputOptionSelect } from "../../../common/InputOptionSelect";
import { TotalProveiderMonth, initialFilterStateForPayable } from "./helper";
import Modal from "react-modal";
import { GetPayableAction } from "../../../redux/actions/PayoutAction";
import { SearchIcon } from "../../../Utils/SvgIcons";
import "../../../assets/css/payout.css";
import PaginatedItems from "../../../common/Pagination";
import { BankDetails } from "./BankDetails";
import { API_URL_WITHOUT_USER } from "../../../Utils/API";
import { getNetworkMenuId, getToken } from "../../../Utils/types";
import CustomPagination from "../../../common/CustomPagination";
import { SubmitUTRBulkUpload } from "./SubmitUTRBulkUpload";
import {
  AdditionalApptHeader,
  payOutHeaderValue,
} from "./AdditionalApptHeader";
import { isLoadingAction } from "../../../Utils/helper";


export const Payable = () => {
  const [providerValues, setProviderValues] = useState(null);
  const [isOpenSetting, setIsOpenSetting] = useState(false);
  const [inputClient, setInputClient] = useState("");
  const [client, setClient] = useState(null);
  const [searchFilter, setSearchFilter] = useState(
    initialFilterStateForPayable
  );
  const [providerDetail, setProviderDetail] = useState([]);
  const [month, setMonth] = useState(null);
  const [header, setHeader] = useState([]);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [submitUtr, setSubmitUtr] = useState({
    isOpen: false,
    rowData: null,
  });

  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const dispatch = useDispatch();
  const [bulkUpload, setBulkUpload] = useState(false);

  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };

  useEffect(() => {
    dispatch(
      GetClientListNetwork({ clientId: 0, clientName: "", BusinessType: "CBU" })
    );
    dispatch(getMonthsYearsAction());
    dispatch(getAllProviderListNetworkAction());
    dispatch(GetPayableAction(searchFilter));
  }, []);

  const handleSearch = () => {
    dispatch(GetPayableAction(searchFilter));
    setProviderDetail([])
  };

  const handleSorting = async (type) => {
    changeHandler("SortDirection", type);
    dispatch(
      GetPayableAction({
        ...searchFilter,
        SortDirection: type,
      })
    );
  };

  const downloadFile = (ele) => {
    isLoadingAction(true, dispatch);
    setIsLoadingExcel(true);
    let prvid = providerDetail.map((ele) => ele?.providerId);
    let payIds = providerDetail.map((ele) => {
      return ele?.payId;
    });

    const url = `${API_URL_WITHOUT_USER}/NetworkPayout/ExportToExcelPayIdDetailsNetwork`;
    let data = {
      ...searchFilter,
      isExportToExcel: true,
      providerIds: prvid.toString(),
      payIds: payIds.length > 1 ? payIds.toString() : ele?.payId?.toString(),
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
        MenuId: getNetworkMenuId()?.menuId,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.blob())
      .then((blob) => {
        isLoadingAction(false, dispatch);
        const filename = "ProviderPayoutDetails.xlsx";
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingExcel(false);
      })
      .catch((error) => {
        console.error("Failed to fetch the file");
        setIsLoadingExcel(false);
      });
  };

  const handleClear = () => {
    setProviderDetail([])
    setClient(null);
    setProviderValues(null);
    setInputClient("");
    setSearchFilter(initialFilterStateForPayable);
    setMonth(new Date().getMonth + 1);
    dispatch(GetPayableAction(initialFilterStateForPayable));
  };

  return (
    <div className="right-section  pt-3" style={{ padding: "10px" }}>
      <div className="card staff-details-section">
        <div className="card-body">
          <h4 className="pt-1">Payables</h4>
          <div className="mt-3 d-flex flex-wrap gap-3  ">
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                style={{ height: "60px" }}
                className="white-form-select "
                value={searchFilter?.BusinessType}
                onChange={(e) => {
                  changeHandler(
                    "BusinessType",
                    e.target.value 
                  );
                  dispatch(
                    GetClientListNetwork({
                      clientId: 0,
                      clientName: "",
                      BusinessType:
                        e.target.value,
                    })
                  );
                  dispatch(GetPayableAction({...searchFilter, BusinessType:
                    e.target.value }));
                }}
              >
                <option value="IBU">IBU</option>
                <option value="CBU">CBU</option>
              </select>
            </div>
            <div className="payputMultiSelect">
              <Select
                placeholder="Select Client"
                getOptionLabel={(option) => option.clientName}
                getOptionValue={(option) => option.clientId}
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                onChange={(event, i,value) => {
                  changeHandler("clients", event);
                }}
                value={
                  searchFilter?.clients === "" ? null : searchFilter?.clients
                }
                inputValue={inputClient}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") setInputClient(value);
                  if(action.action === "menu-close"){
                    setInputClient("")
                  }
                }}
                options={globalReducer?.getClientList?.map((ele) => {
                  return {
                    clientId: ele?.clientId,
                    clientName: ele?.clientName,
                    BusinessType: ele?.businessType,
                  };
                })}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="payputMultiSelect">
              <Select
                placeholder="Provider Name/Code"
                className="basic-multi-select usagecoverage-search"
                classNamePrefix="select"
                isMulti
                styles={placeholderSelectColor}
                closeMenuOnSelect={false}
                name="colors"
                inputValue={providerValues?.input}
                onInputChange={(value, action) => {
                  if (action.action === "input-change") {
                    setProviderValues({
                      ...providerValues,
                      input: value,
                    });
                  }
                  if(action.action === "menu-close"){
                    setProviderValues({
                      ...providerValues,
                      input: "",
                    });
                  }
                }}
                onChange={(event) => {
                  changeHandler(
                    "providerIds",
                    event.map((e) => e.value).toString()
                  );
                  setProviderValues({
                    ...providerValues,
                    options: event,
                  });
                }}
                value={
                  searchFilter?.providerIds === ""
                    ? null
                    : providerValues?.option
                }
                options={TestPackageReducer?.getProviderListNetworkDetails?.map(
                  (ele) => {
                    return {
                      value: ele?.providerId,
                      label: ele?.providerName,
                    };
                  }
                )}
                hideSelectedOptions={false}
                components={{
                  Option: InputOptionSelect,
                }}
              />
            </div>
            <div className="payoutBussinessType">
              <select
                name="BusinessType"
                className="white-form-select "
                style={{ height: "60px" }}
                value={month}
                onChange={(e) => {
                  setMonth(e.target.value);
                  setSearchFilter({
                    ...searchFilter,
                    month: e.target.value ? e.target.value : null,
                  });
                }}
              >
                <option value=""> Select Month</option>
                {globalReducer?.getMonthYear?.lstMonths?.map((ele) => {
                  return (
                    <option value={+ele?.monthId}>{ele?.monthName}</option>
                  );
                })}
              </select>
            </div>
            <div className="payoutBussinessType">
              <select
                name="BusinessType "
                className="white-form-select"
                style={{ height: "60px" }}
                value={searchFilter?.year ? searchFilter?.year : ""}
                onChange={(e) => {
                  setSearchFilter({ ...searchFilter, year: e.target.value });
                }}
              >
                <option value={null}>Select Year</option>
                {globalReducer?.getMonthYear?.lstYears?.map((ele) => {
                  return <option value={ele?.year}>{ele?.year}</option>;
                })}
              </select> 
            </div>
          </div>

          <div className="row-results ">
            <div className="me-5 d-flex gap-1">
              <select
                className="row-selectdropdown"
                value={searchFilter?.rows}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    page: 1,
                    rows: e.target.value,
                  });
                  dispatch(
                    GetPayableAction({
                      ...searchFilter,
                      rows: e.target.value,
                      page: 1,
                    })
                  );
                  // handleDataCount(e);
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <p className="results">
                Total <span>{globalReducer?.getTotalCount}</span> results
              </p>
            </div>
            <div className="d-flex gap-2">
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={handleSearch}
              >
                <a className="sidebar-links">
                  <SearchIcon />
                  <span className="sidebar-link-text">Search</span>
                </a>
              </button>
              <button
                className="search"
                type="button"
                style={{ border: "none" }}
                onClick={() => handleClear("CBU")}
              >
                <a className="sidebar-links">
                  <span className="sidebar-link-text">Clear All</span>
                </a>
              </button>
              <button
                className="btn search__btn"
                type="button"
                style={{ border: "none" }}
                disabled={providerDetail?.length <2}
                // style={{ minWidth: "inherit" }}
                onClick={downloadFile}
              >
                <i className="fa-solid fa-arrow-down"></i> &nbsp; Export To
                Excel
              </button>

              <button
                className="dropdown-toggle appointment-dropdown "
                // style={{ width: "160px" }}
                type="button"
                id="ascDescPayableBtn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="sidebar-link-text">
                  {searchFilter?.SortDirection === "asc"
                    ? "Ascending Order"
                    : "Descending Order"}
                </span>
                <span className="sidebar-link-text">
                  <i className="fa fa-list"></i>
                </span>
              </button>
              <ul className="dropdown-menu" aria-labelledby="ascDescPayableBtn">
                <li>
                  <button
                    className="dropdown-item btn-border-bottom"
                    type="button"
                    onClick={() => handleSorting("asc")}
                  >
                    Ascending Order
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    type="button"
                    onClick={() => handleSorting("desc")}
                  >
                    Descending Order
                  </button>
                </li>
              </ul>
              <button
                className="search__btn ascDescBtn p-2"
                id="ascDescPayableBtn"
               onClick={()=>setIsOpenSetting(true)}
                type="button"
              >
                &nbsp;
                <i class="fa-solid fa-gear" style={{ fontSize: "20px" }}></i>
              </button>
              {/* adde by sanoj */}
              <button
                className="search__btn ascDescBtn p-2"
                id="ascDescPayableBtn"
               onClick={()=>setBulkUpload(true)}
                type="button"
              >
                &nbsp;
                <i className="fa-solid fa-arrow-up"></i> &nbsp; Bulk Submit UTR
              </button>
              {/* adde by sanoj */}
            </div>
          </div>
          <div className="table-responsive __custom__properties">
      <table className="table" style={{ overflow: "hidden" }}>
        <thead>
          <tr>
            <th scope="col">
              <input
                type="checkbox"
                className="form-check-input"
                checked={
                  payoutReducer?.getPayableData?.length ===
                  providerDetail?.length
                }
                onClick={(e) =>
                  e.target.checked
                    ? setProviderDetail(payoutReducer?.getPayableData)
                    : setProviderDetail([])
                }
                readOnly
              />
            </th>
            <th scope="col" style={{minWidth:"130px",textAlign: "center"}}>
              Pay ID
            </th>
            <th scope="col"  style={{minWidth:"80px",textAlign: "center"}}>
              Month
            </th>
            <th
              scope="col"
              // className="financeAdditionalTest"
              style={{minWidth:"280px",textAlign: "left"}}
            >
              Provider Name
            </th>
            <th scope="col" style={{ textAlign: "center" }}>
              Appointment{" "}
            </th>
            <th scope="col" style={{ minWidth:"120px",textAlign: "center" }}>
            Gross Amount  {" "}
            </th>
            <th scope="col" style={{minWidth:"100px", textAlign: "center" }}>
            Net Amount  {" "}
            </th>
            <th scope="col" style={{minWidth:"100px",textAlign: "center"}}>
              {" "}
              Paid Amount
            </th>
            {header.map((ele) => {
              return (
                <th
                  className={`${
                    ele === "Client Name" 
                      ? "financeAdditionalTest"
                      : "addHeader"
                  }`}
                >
                  {ele}
                </th>
              );
            })}
            <th scope="col"  style={{ textAlign: "center" }}>
              Status
            </th>
            <th scope="col" style={{minWidth:"230px",textAlign: "center"}}>
              Action
            </th>
          </tr>
        </thead>
        {payoutReducer?.getPayableData?.length !== 0 && <tbody>
          {payoutReducer?.getPayableData?.map((ele, index) => {
            return (
              <tr key={index}>
                <td>
                  {" "}
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={providerDetail.some((item) => ele === item)}
                    onClick={(e) => {
                      if (e.target.checked) {
                        setProviderDetail([...providerDetail, ele]);
                      } else {
                        setProviderDetail(
                          providerDetail?.filter((item) => ele !== item)
                        );
                      }
                    }}
                    readOnly
                  />
                </td>
                <td style={{ textAlign: "center" }}>
                  {ele?.payReceiptId}
                </td>
                <td >
                  {TotalProveiderMonth(ele?.year, ele?.month)}
                </td>
                <td style={{minWidth:"10px",textAlign: "left"}}>
                  {ele?.providerName}
                </td>
                <td style={{ textAlign: "center" }}>
                  {ele?.totalAppointment}
                </td>
                <td style={{ textAlign: "center"}}>{ele?.grossAmount}</td>
                <td style={{ textAlign: "center" }}>{ele?.netAmount}</td>
                <td style={{ textAlign: "center" }}>{ele?.amountPaid}</td>
                {header.map((col) => {
                  return (
                    <td
                      className={`${
                        col === "Client Name" 
                          ? "financeAdditionalTest"
                          : "addHeader"
                      }`}
                    >
                      {" "}
                      {ele[payOutHeaderValue[col]]}
                    </td>
                  );
                })}
                <td className="width-80" style={{ textAlign: "center" }}>
                  {ele?.requestStatus !== "" && (
                    <p
                      className={`status-style ${
                        ele?.requestStatus === "Paid"
                          ? "approved"
                          : ele?.requestStatus === "Reject By Finance" ||
                            ele?.requestStatus === "Not Paid "
                          ? "rejected"
                          : ele?.requestStatus === "Pending At Finance" ||
                            ele?.requestStatus === "Pending at Network"
                          ? "pendingAtFinance"
                          : ele?.requestStatus === "Pending For Payment"
                          ? "pendingForpayment"
                          : "pending"
                      }`}
                    >
                      {ele?.requestStatus}
                    </p>
                  )}
                </td>
                <td >
                  <div className="d-flex gap-2" style={{justifyContent:"center"}}>
                    <button
                      className="btn search__btn action_export"
                      type="button"
                      onClick={() => downloadFile(ele)}
                    >
                      <i className="fa-solid fa-file-csv"></i>&nbsp;
                      Export
                    </button>
                    <button
                    
                      className="btn search__btn action_export viewUtrBtn"
                      type="button"
                      id="viewUtrBtn"
                      data-bs-toggle="modal"
                      data-bs-target="#sendToQcModal"
                      disabled = {getNetworkMenuId()?.canEdit === false && ele?.requestStatus !== "Paid"}
                      onClick={() => {
                        setSubmitUtr({ isOpen: true, rowData: ele });
                      }}
                    >
                      {ele?.requestStatus === "Paid"
                        ? "View UTR"
                        : "Submit UTR"}
                      &nbsp;
                      <i class="fa-solid fa-caret-right"></i>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>}
        
      </table>
    </div>
        {payoutReducer?.getPayableData?.length === 0 && <p className="noRecordFound">No Record Found</p>}
        {}

          <div className="d-flex justify-content-between">
            <div className="pagination-row">
              {globalReducer?.getTotalCount !== 0 && (
                <CustomPagination
                  totalCount={globalReducer?.getTotalCount}
                  perPageData={searchFilter?.rows}
                  searchFilter={searchFilter}
                  setSearchFilter={setSearchFilter}
                  apiCall={GetPayableAction}
                  IsPayoutStatus={true}
                />
              )}
            </div>
          </div>
          <Modal
            isOpen={submitUtr?.isOpen}
            className="modal-add-user-popup   bankDetailwidth"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <BankDetails
              submitUtr={submitUtr}
              setSubmitUtr={setSubmitUtr}
              searchFilter={searchFilter}
            />
          </Modal>
          <Modal
            isOpen={isOpenSetting}
            // style={{maxWidth:"35%"}}
            className=" modal-add-user-popup modal-upload-excel-popup payOutAddHeader"
            overlayClassName="overlay-history-popup network-z-index"
            ariaHideApp={false}
          >
            <AdditionalApptHeader
            setIsOpenSetting={setIsOpenSetting}
              header={header}
              setHeader={setHeader}
              searchFilter={searchFilter}
            />
          </Modal>
           {/* added by sanoj */}
           <Modal
                  isOpen={bulkUpload}
                  className=" modal-add-user-popup modal-upload-excel-popup"
                  overlayClassName="overlay-history-popup network-z-index"
                  ariaHideApp={false}
                >
                  <SubmitUTRBulkUpload
                    setBulkUpload={setBulkUpload}
                    bulkUpload={bulkUpload}
                  />
                </Modal>

                {/* endded by sanoj */}
        </div>
      </div>
    </div>
  );
};
